<template>
  <div id="page-user-edit">

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="Fee" icon-pack="feather" icon="icon-dollar-sign">
            <div class="tab-text">
              <user-add-tab-account class="mt-4"/>
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import UserAddTabAccount     from './UserAddTabAccount.vue'

export default {
  components: {
    UserAddTabAccount
  }
}

</script>
